import { TableContentWithoutEdit, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const total = this.props.total;

        return (
            <div>
                <h3><center><u>Route Employee Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row">
                    <div className="row alternative_cls">

                        <div className="col pb-2 width4">
                            <table
                                className="display dataTable no-footer pt-3 pb-3">
                                <thead>
                                    <tr>
                                        <th>Route Name</th>
                                        <th>Route Code</th>
                                        <th>Employee Type</th>
                                        <th>Employee Name</th>
                                        <th>IN</th>
                                        <th>OUT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentWithoutEditDateFromat
                                        data={data}
                                        contentRowNames={rowNames}
                                    />
                                </tbody>
                            </table>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );
    }
}